export const parseShowDate = (timestamp) => {
  const options = { year: "numeric", month: "long", day: "numeric" };
  let formattedDate = new Date(timestamp).toLocaleDateString("en-US", options);
  return <p className="">{formattedDate.toString()}</p>;
};

export const parseShowTime = (timestamp) => {
  return new Date(timestamp).toLocaleTimeString("en", {
    timeStyle: "short",
    hour12: true,
    timeZone: "UTC",
  });
};
